import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

var AbstractCalculator =
/*#__PURE__*/
_createClass(function AbstractCalculator() {
  _classCallCheck(this, AbstractCalculator);
});

export default AbstractCalculator;